export default function getScrollTop() {
  return document.body.scrollTop || document.documentElement.scrollTop;
}
